import { produce } from 'immer';
export const applyToggledFeaturesToInstitutionInfo = (institutionInfo, siteId, toggledFeatures) => produce(institutionInfo, draft => {
    const affectedSite = draft.institutions.find(site => site.institutionId === siteId);
    if (affectedSite === undefined) {
        return;
    }
    toggledFeatures.forEach(feature => {
        const affectedManagedFeature = affectedSite.managedFeatures.find(managedFeature => managedFeature.featureId === feature.featureId);
        if (affectedManagedFeature === undefined) {
            return;
        }
        affectedManagedFeature.enabled = feature.enabled;
    });
});
